import styled from 'styled-components';

export const TrailWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing.level4} 0;
`;

export const TrailHeader = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level3};
  width: 100%;
  padding: ${({ theme }) => theme.spacing.level3} 0;
  border: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.outlineVariant};
  background: transparent;
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
  ${({ theme }) => theme.font.bodyMedium};
  text-align: left;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.onSurface};
  }
`;

export const TrailTitle = styled.span`
  flex-shrink: 0;
  white-space: nowrap;
`;

export const TrailMeta = styled.span`
  ${({ theme }) => theme.font.bodySmall};
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: 0.8;
`;

export const TrailFailed = styled.span`
  color: ${({ theme }) => theme.colors.error};
`;

export const TrailChevron = styled.span<{ $expanded: boolean }>`
  display: inline-flex;
  flex-shrink: 0;
  font-size: 18px;
  transition: transform 0.2s ease;
  transform: rotate(${({ $expanded }) => ($expanded ? '90deg' : '0deg')});
`;

export const TrailBody = styled.div`
  margin: ${({ theme }) => theme.spacing.level3} 0;
  padding-left: ${({ theme }) => theme.spacing.level5};
  border-left: 2px solid ${({ theme }) => theme.colors.outlineVariant};

  &[hidden] {
    display: none;
  }
`;
